import axios from "axios";
import React, { Component, useState, useEffect, useContext, lazy, Suspense } from "react";
import queryString from "query-string";
import { Cookies } from "../../../../index.js";
import { Helmet } from "react-helmet";
import AdSense from 'react-adsense';
import BitmediaAd from '../../../mission/bitmedia';
import { FaRegClock } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../../../AppContext";
import { ClipLoader } from "react-spinners";
import Buylink from './../../urlshorten_system/buy_link.jsx';
import Login_google from '../../urlshorten_logic/login.jsx';
const LazyReCAPTCHA = lazy(() => import("../../../../app_structure/LazyReCAPTCHA"));
function Capdo12(props) {
  const capdo12 = props.data;
  const money = props.money;
  const note = props.note;
  const [hustmediavipro, sethustmediavipro] = useState("");
  const [apikey, setapikey] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lienketjop, setlienketjop] = useState("");
  const [disabledbutton, setdisabledbutton] = useState(true);
  const [count, setCount] = useState(10);
  // Gọi hàm alert_error
  const [dataCaptcha, setdataCaptcha] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [lienket, setLienket] = useState("");
  const recaptchaRef = React.createRef();
  const [nutxuly, setnutxuly] = useState("");
  const [buttonTextjop, setbuttonTextjop] = useState("");
  const [code3, setcode3] = useState("");
  const navigate = useNavigate();

  function handleChange(asdasdasd) {
    if (asdasdasd.status == 1) {
      setnutxuly(0);
      const lienketjop = asdasdasd.order;
      console.log(lienketjop);
      props.onLienKetChange(lienketjop); // gọi hàm từ props để cập nhật liên kết trong component cha
      alert_success('Xác thực thành công');
      setbuttonTextjop("Hust Media cảm ơn bạn đã ghé thăm");
    } else {
      alert_error('Đã xảy ra lỗi tải lại trang nhé');
    }

  }



  useEffect(() => {
    const intervalId = setInterval(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    if (count == 0) {
      setbuttonTextjop('Xác nhận bạn không phải người máy');
      setdisabledbutton(false);
      clearInterval(intervalId);
      // xử lý khi đếm ngược hoàn thành
    }

    return () => clearInterval(intervalId);
  }, [count]);
  useEffect(() => {

    setIsLoading(true);
    setbuttonTextjop('Đang tải dữ liệu Please wait a moment 😊');
    setTimeout(() => {
      if (capdo12 == 1) {
        setdisabledbutton(false);
        setbuttonTextjop('Xác nhận bạn không phải người máy');
      }
      else if (capdo12 == 2) {

      }

      setIsLoading(false);
      setShowCaptcha(true);
    }, 2700);
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      setapikey(myCookieValue);
    }
    const hustmediavipro = Cookies.get("hustmediavipro");
    sethustmediavipro(hustmediavipro);
  }, []);

  return (
    <div>


      <form className="add-form" >
        <div className="form-control">
          <div style={{ textAlign: "center" }} className="mt-0   justify-center items-center ">

            <Helmet>
              <script src="https://www.vipads.live/vn/E63DE5E9-83A2-727-33-C9472C085EBB.blpha"></script>
            </Helmet>

            {apikey ? (<><Buylink money={money} capdo={capdo12} hustmediavipro={hustmediavipro} /></>) : (<>
              <div className="mb-1 ">
                <div>Đăng nhập google để mua link</div>
                <Login_google />
              </div>
            </>)}

            <BitmediaAd />
            <div className="mt-2 flex flex-wrap  justify-center">
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe>
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe>
              <iframe
                data-aa="2271984"
                src="//ad.a-ads.com/2271984?size=320x50"
                frameBorder="0"
                scrolling="no"
                allowFullScreen
                style={{
                  width: '320px',
                  height: '50px',
                  border: 0,
                  padding: 0,
                  overflow: 'hidden',
                  backgroundColor: 'transparent'
                }}
              ></iframe></div>
          </div></div>
      </form>
    </div>
  );
}

export default Capdo12;
